import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"



const AboutActs = ({ image }) => {
  return (
    <ImgItem>
      <div className="textWrapper">
        <h1>Acts</h1>

        <p1>
          As easy as it looks, tap Act Down when you are ready to move on.
          Start unlimited In-Act Timers. Ever needed to time the length of a
          scene or feature? Simply tap the "Start a Timer" button and away you
          go.

          You can also preview all times, Show Stops, and Timers. This will
          calculate running and playing time up to the current act.

          If you ever move forward by mistake, all Act and Interval screens
          have a reset and back button which can take you back to where you
          left off.
        </p1>
      </div>

      <Img
        fluid={image.childImageSharp.fluid}
        alt="Acts screen"
        className="image"
      />
    </ImgItem>
  )
}

export default AboutActs